import React from 'react';
import {Link} from 'react-router-dom';

import {userServices} from '../../../../services';
import InstructionLayout, {
    InstructionSpotlight,
    InstructionStep
} from '../instruction-layout';


const openSettingsItems = [
    {
        id: 'cabinet',
        number: 1,
        content: (
            <>
                Перейдите в раздел <strong>«Кабинет»</strong>.
            </>
        ),
        area: {
            top: 1.4,
            left: 51.5,
            width: 5.2,
            height: 5
        }
    },
    {
        id: 'notifications',
        number: 2,
        content: (
            <>
                Откройте вкладку
                <strong> «Уведомления»</strong>.
            </>
        ),
        area: {
            top: 71.19,
            left: 2.95,
            width: 21.91,
            height: 5.18
        }
    },
    {
        id: 'notification-settings',
        number: 3,
        content: (
            <>
                Нажмите кнопку
                <strong> «Настройки уведомлений»</strong>.
            </>
        ),
        area: {
            top: 24.16,
            left: 78.66,
            width: 16.46,
            height: 5.18
        }
    }
];


const notificationMethodItems = [
    {
        id: 'site',
        number: 1,
        content: (
            <>
                Отметьте уведомления, которые необходимо получать
                на <strong>сайте</strong>.
            </>
        ),
        area: {
            top: 5,
            left: 0,
            width: 25,
            height: 95
        }
    },
    {
        id: 'messenger',
        number: 2,
        content: (
            <>
                Отметьте уведомления, которые необходимо получать
                в <strong>Telegram или MAX</strong>.
            </>
        ),
        area: {
            top: 5,
            left: 24.6,
            width: 25,
            height: 95
        }
    },
    {
        id: 'email',
        number: 3,
        content: (
            <>
                Отметьте уведомления, которые необходимо получать
                по <strong>электронной почте</strong>.
            </>
        ),
        area: {
            top: 5,
            left: 49.3,
            width: 25,
            height: 95
        }
    },
    {
        id: 'application',
        number: 4,
        content: (
            <>
                Отметьте уведомления, которые необходимо получать
                в <strong>приложении</strong>.
            </>
        ),
        area: {
            top: 5,
            left: 73.8,
            width: 25,
            height: 95
        }
    }
];


const distributionCenterItems = [
    {
        id: 'distribution-centers',
        number: 1,
        content: (
            <>
                Выберите распределительные центры, по которым
                необходимо получать уведомления.
            </>
        ),
        area: {
            top: 34,
            left: 1,
            width: 68,
            height: 48
        }
    }
];


const carrierNotificationItems = [
    {
        id: 'carrier-methods',
        number: 1,
        content: (
            <>
                Выберите способы получения уведомлений
                о новых рейсах и изменениях заявок.
            </>
        ),
        area: {
            top: 3.48,
            left: 1.14,
            width: 97.96,
            height: 35.35
        }
    },
    {
        id: 'carrier-regions',
        number: 2,
        content: (
            <>
                Укажите регионы, по которым необходимо получать
                уведомления о новых рейсах.
            </>
        ),
        area: {
            top: 40,
            left: 1.14,
            width: 97.96,
            height: 60
        }
    }
];


export default function NotificationsInstruction() {
    const user = userServices.getUser();
    const isCarrier =
        user &&
        user.info &&
        user.info.userType === 'carrier';
    const notificationSettingsPath = isCarrier
        ? '/company/user-notification-settings'
        : '/consignor/user-notification-settings';

    return (
        <InstructionLayout title="Настройка уведомлений">
            <p className="instruction-intro">
                В личном кабинете можно выбрать необходимые уведомления,
                удобный способ их получения и распределительные центры,
                по которым должна поступать информация.
            </p>

            <div className="instruction-callout">
                <div className="instruction-callout__content">
                    <strong className="instruction-callout__title">
                        Быстрый переход к настройкам уведомлений
                    </strong>

                    <p className="instruction-callout__text">
                        Если вы уже знакомы с настройками, перейдите сразу
                        на страницу управления уведомлениями.
                    </p>
                </div>

                <Link
                    className="instruction-callout__link"
                    to={notificationSettingsPath}
                >
                    Перейти к настройкам
                </Link>
            </div>

            <InstructionStep
                number="1"
                title="Откройте настройки уведомлений"
            >
                <div className="instruction-copy">
                    <p>
                        Перейдите в личный кабинет, откройте список
                        уведомлений и перейдите к настройкам.
                    </p>
                </div>

                <InstructionSpotlight
                    src="/img/instructions/notifications/01-notifications-button.png"
                    alt="Переход к настройкам уведомлений"
                    items={openSettingsItems}
                />
            </InstructionStep>

            <InstructionStep
                number="2"
                title="Выберите уведомления и способы получения"
            >
                <div className="instruction-copy">
                    <p>
                        Для каждого необходимого уведомления отметьте
                        один или несколько удобных способов получения.
                    </p>
                </div>

                <InstructionSpotlight
                    src="/img/instructions/notifications/02-notification-options.png"
                    alt="Выбор уведомлений и способов их получения"
                    items={notificationMethodItems}
                />
            </InstructionStep>

            <InstructionStep
                number="3"
                title="Выберите распределительные центры"
            >
                <div className="instruction-copy">
                    <p>
                        Укажите распределительные центры, информация
                        по которым должна поступать в уведомлениях.
                    </p>
                </div>

                <InstructionSpotlight
                    src="/img/instructions/notifications/03-distribution-centers.png"
                    alt="Выбор распределительных центров для уведомлений"
                    items={distributionCenterItems}
                />
            </InstructionStep>

            <InstructionStep
                number="4"
                title="Настройте уведомления о новых рейсах"
            >
                <div className="instruction-copy">
                    <p>
                        Для перевозчиков доступны дополнительные
                        настройки уведомлений о новых рейсах:
                        способы получения и интересующие регионы.
                    </p>
                </div>

                <InstructionSpotlight
                    src="/img/instructions/notifications/04-carrier-notifications.png"
                    alt="Настройка уведомлений о новых рейсах для перевозчика"
                    items={carrierNotificationItems}
                />
            </InstructionStep>
        </InstructionLayout>
    );
}